import React from 'react'
import { useParams } from 'react-router-dom'

import { Panel } from 'rsuite'
import UsersStatistic from '@components/users/stats/UsersStatistic'
import UsersManagementTable from '@components/users/table/UsersManagementTable'

export default function UsersManagementPage () {
  const { type = null } = useParams<any>()
  const [ title, setTitle ] = React.useState<string>('Сотрудники')

  return (
    <div className="UsersManagementPage">
      <h1 className="u-heading">{ title }</h1>
      <UsersManagementTable 
        type={type} 
        onChangePage={setTitle} 
      />
      { !type && <UsersStatistic /> }
    </div>
  )
}
